import { ContactCard } from 'modules/contactCards/types';
import { OptOutType } from 'modules/globalSms/types';
import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';
import { PreviewWithDataErrorMessage } from '../../common';

export interface SMSPreviewContextState {
  hasAlphanumericSupport: boolean;
  isLoading: boolean;
  messageContent: string;
  onRefreshPreview: NoOp;
  optOutType: OptOutType;
  previewContactCard?: ContactCard;
  previewError?: PreviewWithDataErrorMessage;
  setOptOutType: (value: OptOutType) => void;
  /** Should the opt-out message be shown in the sms? */
  optInMessageIsShown: boolean;
  /** Toggle whether to show the opt-out message in the sms */
  setOptInMessageIsShown: (value: boolean) => void;
  /** Full SMS, including opt-out if `optInMessageIsShown` is true */
  fullSmsMessage: string;
}

export const SMSPreviewContext = createContext<SMSPreviewContextState>({
  hasAlphanumericSupport: false,
  isLoading: false,
  messageContent: '',
  onRefreshPreview: noop,
  optOutType: OptOutType.ALPHANUMERIC,
  previewContactCard: undefined,
  previewError: undefined,
  setOptOutType: noop,
  optInMessageIsShown: true,
  setOptInMessageIsShown: noop,
  fullSmsMessage: '',
});

export const useSMSPreviewContext = () => useContext(SMSPreviewContext);
